import { Company } from './company'

const COMPANIES_SEARCH_MAX_PAGE_SIZE = 100

export type CompaniesSearchSortDirection = 'asc' | 'desc'
export type CompaniesSearchSortField = 'createdDateTime' | 'name' | 'status' | string

export type CompaniesSearchSort = {
  field: CompaniesSearchSortField
  direction: CompaniesSearchSortDirection
}

export type CompaniesSearchPaging = {
  page?: number
  pageSize?: number
}

export type CompaniesSearchRolesFilter = {
  requireNotNone?: boolean
  requireNone?: boolean
  includeAny?: Array<string> | string
  includeAll?: Array<string> | string
  excludeAny?: Array<string> | string
}

type TextFilter = string | { contains?: string; isNullOrEmpty?: boolean }

export type CompaniesSearchRequest = {
  paging?: CompaniesSearchPaging
  sort?: Array<CompaniesSearchSort>
  scope?: 'All' | 'CompaniesOnly' | 'CustomersOnly'
  hasParent?: boolean
  hasChildren?: boolean
  parentId?: string
  id?: string
  name?: TextFilter
  customer?: {
    email?: TextFilter
    firstName?: TextFilter
    lastName?: TextFilter
    phoneNumber?: TextFilter
  }
  company?: {
    siret?: TextFilter
    siren?: TextFilter
    vat?: TextFilter
  }
  roles?: CompaniesSearchRolesFilter
}

export type CompaniesSearchResponse = {
  items: Array<Company>
  page: number
  pageSize: number
  totalCount: number
}

export { COMPANIES_SEARCH_MAX_PAGE_SIZE }
